export const mutations = {
  setStep(state, step) {
    state.step = step;
  },
  setTotalSteps(state, totalSteps) {
    state.totalSteps = totalSteps;
  },
  setOnCancel(state, onCancel) {
    state.onCancel = onCancel;
  },
  setOnNext(state, onNext) {
    state.onNext = onNext;
  },
  setFormData(state, formData) {
    state.formData = formData;
  },
  setPromo(state, promo) {
    state.promo = promo;
  }
};

export const actions = {
  async submitForm({ state, dispatch }) {
    try {
      const payload = {
        cancelReasons: this.$g('CANCELLATION_REASONS')
          .map((reason) => Number(reason.value === state.formData.reason))
          .join(','),
        otherReasonText: '',
        cancelFeedback: `
        ${state.formData.satisfactionScale}, ${state.formData?.satisfactionDescription || ''}`,
        technicalReason: 'USER_CANCELLED'
      };

      const response = await dispatch('user/SEND_CANCELLATION', payload, { root: true });
      if (response.error && response?.message) {
        throw new Error(`main.profile.cancellation.${response.message}`);
      }
    } catch (error) {
      if (error.message) {
        throw error;
      }
      throw new Error('Something went wrong');
    }
  },
  async loadPromo({ commit }) {
    try {
      const { data } = await this.$axiosUtils.get('configurations/?config=promo_plan');
      if (data.error) throw new Error();
      if (!data.data?.id) throw new Error();
      commit('setPromo', data.data);
    } catch {
      commit('setPromo', null);
    }
  }
};

export const getters = {
  getState(state) {
    return state;
  }
};

export const state = () => ({
  step: 1,
  totalSteps: 3,
  // null y no una funcion: el state se serializa en window.__NUXT__ para la
  // hidratacion y una funcion ahi genera "Cannot stringify a function". Las
  // paginas de cancellation commitean los handlers reales en mounted().
  onCancel: null,
  onNext: null,
  formData: {},
  promo: null
});
